import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3a8bb1c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%","overflow-x":"hidden"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"86px","margin-left":"10%"} }, [
    /*#__PURE__*/_createElementVNode("div", { class: "banner-text1" }, [
      /*#__PURE__*/_createElementVNode("span", null, "首页"),
      /*#__PURE__*/_createTextVNode(" > "),
      /*#__PURE__*/_createElementVNode("span", null, "互认标准"),
      /*#__PURE__*/_createTextVNode(" > "),
      /*#__PURE__*/_createElementVNode("span", null, "常见问题")
    ]),
    /*#__PURE__*/_createElementVNode("div", {
      class: "banner-text2",
      style: {"margin-top":"30px"}
    }, "常见问题")
  ])
], -1))
const _hoisted_3 = { class: "box6" }
const _hoisted_4 = { class: "navbox" }
const _hoisted_5 = ["onClick", "onMouseover", "onMouseout"]
const _hoisted_6 = { class: "navText" }
const _hoisted_7 = { class: "indicator" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line1" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "简化流程：设计简洁直观的操作流程；", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。", -1))
const _hoisted_18 = { class: "pagination" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, null, -1))

import { reactive, toRefs, ref } from 'vue'



export default /*#__PURE__*/_defineComponent({
  __name: 'askedQuestion',
  setup(__props) {

let tabsList = ref([
    { name: '政策业务', isHovered: false, isActive: true, },
    { name: '标准规范', isHovered: false, isActive: false, },
    { name: '互认接入', isHovered: false, isActive: false, },
    { name: '技术对接', isHovered: false, isActive: false, },
    { name: '操作使用', isHovered: false, isActive: false, },
    { name: '其他', isHovered: false, isActive: false, },
])
let activeName = ref('1')
const toggleActive = (item: any) => {
    tabsList.value.map((item: any) => {
        item.isActive = false;
    })

    item.isActive = true;
    activeName.value = item.value
}

let currentPage = ref(1)
let pageSize = ref(100)


return (_ctx: any,_cache: any) => {
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabsList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["nav", { active: item.isActive }]),
              onClick: ($event: any) => (toggleActive(item)),
              onMouseover: ($event: any) => (item.isHovered = true),
              onMouseout: ($event: any) => (item.isHovered = false)
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(item.name), 1),
                _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
                  [_vShow, item.isActive]
                ])
              ])
            ], 42, _hoisted_5))
          }), 128))
        ]),
        _hoisted_8,
        _createVNode(_component_el_collapse, {
          modelValue: _ctx.activeNames,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeNames) = $event)),
          onChange: _ctx.handleChange,
          style: {"margin-top":"0px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_collapse_item, {
              title: "如何查看TOS账单？",
              name: "1"
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, {
              title: "TOS支持哪些类型的资源包？",
              name: "2"
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, {
              title: "资源包支持退款吗？",
              name: "3"
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                _hoisted_14,
                _hoisted_15
              ]),
              _: 1
            }),
            _createVNode(_component_el_collapse_item, {
              title: "如何关闭TOS服务？",
              name: "4"
            }, {
              default: _withCtx(() => [
                _hoisted_16,
                _hoisted_17
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_el_pagination, {
          "current-page": _unref(currentPage),
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentPage) ? (currentPage).value = $event : currentPage = $event)),
          "page-size": _unref(pageSize),
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => (_isRef(pageSize) ? (pageSize).value = $event : pageSize = $event)),
          "page-sizes": [100, 200, 300, 400],
          layout: "prev, pager, next,sizes,",
          total: 1000,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.handleCurrentChange
        }, null, 8, ["current-page", "page-size", "onSizeChange", "onCurrentChange"])
      ]),
      _hoisted_19
    ])
  ]))
}
}

})